/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Organizationid_Placeholder1Inputs */

const en__field_organizationid_placeholder1 = /** @type {(inputs: _Field_Organizationid_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The organization this belongs to`)
};

/** @type {(inputs: _Field_Organizationid_Placeholder1Inputs) => LocalizedString} */
const de__field_organizationid_placeholder1 = en__field_organizationid_placeholder1;

/**
* | output |
* | --- |
* | "The organization this belongs to" |
*
* @param {_Field_Organizationid_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_organizationid_placeholder1 = /** @type {((inputs?: _Field_Organizationid_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Organizationid_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_organizationid_placeholder1(inputs)
	return de__field_organizationid_placeholder1(inputs)
});
export { _field_organizationid_placeholder1 as "_field_organizationId_placeholder" }